// extracted by mini-css-extract-plugin
module.exports = {"container":"product-type_container__35hOG","icon":"product-type_icon__1LWMb"};